export default __webpack_public_path__ + "static/media/reunion23_w320.027a8589.jpg";